.promo-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  box-shadow: var(
    --mdc-dialog-container-elevation,
    0 11px 15px -7px rgb(0 0 0 / 20%),
    0 24px 38px 3px rgb(0 0 0 / 14%),
    0 9px 46px 8px rgb(0 0 0 / 12%)
  ) !important;
  max-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
  border-radius: var(--mdc-dialog-container-shape, 4px);
  opacity: 1;
  outline: none;
  font-family: $font-family-02;

  @media (min-width: 801px) {
    width: 800px;
    height: auto;
  }

  @media (max-width: 800px) {
    width: 100vw;
    height: auto;
  }

  @media (max-width: 719px) {
    top: 0;
    transform: translate(-50%, 0);
  }

  @media (max-width: 450px) {
    padding: 70px 0;
  }

  &-overlay {
    position: fixed;
    height: 100%;
    width: 100%;
    z-index: 1000;
    top: 0;
    left: 0;
    display: block;
    background: rgb(0 0 0 / 32%);
  }

  &__header {
    display: flex;
    padding: 24px 32px;
    align-items: flex-start;
    gap: 8px;
    justify-content: space-between;
    border-bottom: 1px solid #d6d9e0;

    @media (min-width: 991px) {
      padding: 32px;
    }

    h1 {
      font-family: $font-family-02;
      font-size: 24px;
      line-height: 1.25;
      font-weight: 400;
      outline: none;
      box-shadow: none;

      @media (min-width: 991px) {
        font-size: 28px;
      }
    }
  }

  &-icon {
    display: flex;
    align-items: flex-start;
    cursor: pointer;
  }

  &__content {
    background-color: #f7f7f9;
    /* stylelint-disable-next-line selector-class-pattern */
    .promo-dialog__content-container {
      display: flex;
      padding: 32px;
      flex-direction: column;
      align-items: flex-start;
    }

    &-header {
      font-family: $font-family-02;
      font-size: 18px;
      line-height: 1.25;
      font-weight: $font-weight-semi-bold;
    }
  }

  &__body {
    display: flex;
    padding: 24px 32px;
    flex-direction: column;
    gap: 8px;

    label {
      font-size: 18px;
      line-height: normal;
      font-weight: $font-weight-semi-bold;
    }

    input {
      border-radius: 4px;
      border: 1px solid #9e9e9e;
      outline: none;
      box-shadow: none;
      height: 56px;
      padding-left: 16px;
      margin: 1px;

      &:hover {
        border: 1px solid rgb(43 46 49);
      }

      &:focus {
        border: 2px solid rgb(63 81 181);
        margin: 0;
      }

      /* stylelint-disable-next-line selector-class-pattern */
      &.promo-dialog__input--error {
        border: 1px solid #f44336;

        &:focus {
          border-width: 2px;
        }
      }
    }
  }

  /* stylelint-disable-next-line selector-class-pattern */
  .promo-dialog__body-error {
    display: flex;
    align-items: center;
    gap: 8px;

    /* stylelint-disable-next-line selector-class-pattern */
    .promo-dialog__body-error-text {
      color: #ce2a3e;
    }
  }

  &__button-container {
    padding: 0 !important;
  }

  &__footer {
    display: flex;
    padding: 24px;
    flex-direction: row;
    gap: 24px;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #d6d9e0;

    /* stylelint-disable-next-line selector-class-pattern */
    .promo-dialog__footer-error {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      flex: 1;
      outline: none !important;
      box-shadow: none !important;
    }

    /* stylelint-disable-next-line selector-class-pattern */
    .promo-dialog__footer-error-text {
      align-items: flex-start;
      color: #ce2a3e;
      margin-bottom: 0;
    }

    /* stylelint-disable-next-line selector-class-pattern */
    .promo-dialog__footer-submit-button {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-left: auto;
      min-width: 160px;
    }
  }

  .trusted-content-container a,
  .trusted-content-container a:active,
  .trusted-content-container a:focus,
  .trusted-content-container a:visited {
    color: $c-primary-01 !important;
    font-weight: $font-weight-semi-bold !important;

    u {
      color: $c-primary-01 !important;
      font-weight: $font-weight-semi-bold !important;
    }
  }

  &__focus-trap {
    outline: none !important;
    box-shadow: none !important;
  }

  &__hint-text {
    font-size: 12px;
  }

  &__error-icon {
    display: flex;
  }
}
